import { render, staticRenderFns } from "./CallEventsDetail.vue?vue&type=template&id=0ebf68ba&"
import script from "./CallEventsDetail.vue?vue&type=script&lang=ts&"
export * from "./CallEventsDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports